import { refreshTokenRequest } from '@inno-tools/api-middleware'

import { middlewareController } from '../../../middlewareController'

export const refresh = async () => {
  const authEndpoint = process.env.REACT_APP_AUTH_ENDPOINT as string
  return refreshTokenRequest(authEndpoint, middlewareController.refreshToken())
}
